import moment from 'moment'
import {
    TOWER_DEPROP_1,
    TOWER_DEPROP_2,
    TOWER_DEPROP_3,
    TOWER_DEPROP_4,
    TOWER_DEBUT_1,
    TOWER_DEBUT_3,
    TOWER_DEBUT_4,
    TOWER_SPLITTER_1,
    TOWER_SPLITTER_3,
    TOWER_SPLITTER_4,
    TOWER_SPLITTER_6,
    TOWER_UPGRADER,
    TOWER_DEPROP_1_HoursOffline,
    TOWER_DEPROP_1_Reason,
    TOWER_DEPROP_2_HoursOffline,
    TOWER_DEPROP_2_Reason,
    TOWER_DEPROP_3_HoursOffline,
    TOWER_DEPROP_3_Reason,
    TOWER_DEPROP_4_HoursOffline,
    TOWER_DEPROP_4_Reason,
    TOWER_DEBUT_1_HoursOffline,
    TOWER_DEBUT_1_Reason,
    TOWER_DEBUT_3_HoursOffline,
    TOWER_DEBUT_3_Reason,
    TOWER_DEBUT_4_HoursOffline,
    TOWER_DEBUT_4_Reason,
    TOWER_SPLITTER_1_HoursOffline,
    TOWER_SPLITTER_1_Reason,
    TOWER_SPLITTER_3_HoursOffline,
    TOWER_SPLITTER_3_Reason,
    TOWER_SPLITTER_4_HoursOffline,
    TOWER_SPLITTER_4_Reason,
    TOWER_SPLITTER_6_HoursOffline,
    TOWER_SPLITTER_6_Reason,
    TOWER_UPGRADER_HoursOffline,
    TOWER_UPGRADER_Reason,
    TOWER_DEPROP_1_ADJHRSOFFLINE,
    TOWER_DEPROP_2_ADJHRSOFFLINE,
    TOWER_DEPROP_3_ADJHRSOFFLINE,
    TOWER_DEPROP_4_ADJHRSOFFLINE,
    TOWER_DEBUT_1_ADJHRSOFFLINE,
    TOWER_DEBUT_3_ADJHRSOFFLINE,
    TOWER_DEBUT_4_ADJHRSOFFLINE,
    TOWER_SPLITTER_1_ADJHRSOFFLINE,
    TOWER_SPLITTER_3_ADJHRSOFFLINE,
    TOWER_SPLITTER_4_ADJHRSOFFLINE,
    TOWER_SPLITTER_6_ADJHRSOFFLINE,
    TOWER_UPGRADER_ADJHRSOFFLINE
} from '../constants/towerNames'
import {
    DEPROP1_PI_TAG,
    DEPROP2_PI_TAG,
    DEPROP3_PI_TAG,
    DEPROP4_PI_TAG,
    DEBUT1_PI_TAG,
    DEBUT3_PI_TAG,
    DEBUT4_PI_TAG,
    SPLITTER1_PI_TAG,
    SPLITTER3_PI_TAG,
    SPLITTER4_PI_TAG,
    SPLITTER6_PI_TAG,
    UPGRADER_PI_TAG
} from '../constants/piTags'
import {
    paintColumnInGrey,
    gridCellClassRulesEditable,
    gridCellClassRulesNonEditable
} from '../utils'

const reasonCodes = ['', 'SM', 'UM', 'TA', 'LOF', 'PO', 'PI']

export const columnDefinition = () => {
    return [
        {
            headerName: 'Date',
            field: 'Date',
            resizable: true,
            pinned: 'left',
            filter: 'agTextColumnFilter',
            floatingFilter: true,
            cellRenderer: (params) => {
                if (params?.value) {
                    const formattedDate = moment(params.value).format('DD-MMM-YYYY')
                    return formattedDate
                }
                return
            },
            width: 110,
            headerClass: 'ag-header-tc-date'
        },
        {
            headerName: 'Depropanizers',
            children: [
                {
                    headerName: TOWER_DEPROP_1,
                    field: "TOWER_DEPROP_1",
                    headerTooltip: DEPROP1_PI_TAG,
                    children: [
                        {
                            field: TOWER_DEPROP_1_HoursOffline,
                            headerName: 'Hrs Offline',
                            width: 85,
                            filter: 'agNumberColumnFilter',
                            floatingFilter: true,
                            cellStyle: (params) => paintColumnInGrey(params)
                        },
                        {
                            field: TOWER_DEPROP_1_ADJHRSOFFLINE,
                            headerName: 'Adj Hrs Offline',
                            width: 85,
                            cellEditor: "NumericCellEditor",
                            editable: params => true,
                            cellClassRules: gridCellClassRulesEditable,
                        },
                        {
                            headerName: 'Reason',
                            field: TOWER_DEPROP_1_Reason,
                            type: 'text',
                            width: 75,
                            filter: 'agTextColumnFilter',
                            floatingFilter: true,
                            cellEditor: "agSelectCellEditor",
                            cellEditorParams: { values: reasonCodes },
                            editable: params => true
                        },
                    ]
                },
                {
                    headerName: TOWER_DEPROP_2,
                    field: 'TOWER_DEPROP_2',
                    headerTooltip: DEPROP2_PI_TAG,
                    children: [
                        {
                            field: TOWER_DEPROP_2_HoursOffline,
                            headerName: 'Hrs Offline',
                            width: 85,
                            filter: 'agNumberColumnFilter',
                            floatingFilter: true,
                            cellStyle: (params) => paintColumnInGrey(params)
                        },
                        {
                            field: TOWER_DEPROP_2_ADJHRSOFFLINE,
                            headerName: 'Adj Hrs Offline',
                            cellEditor: "NumericCellEditor",
                            width: 85,
                            editable: params => true,
                            cellClassRules: gridCellClassRulesEditable,
                        },
                        {
                            headerName: 'Reason',
                            field: TOWER_DEPROP_2_Reason,
                            width: 75,
                            filter: 'agTextColumnFilter',
                            floatingFilter: true,
                            cellEditor: "agSelectCellEditor",
                            cellEditorParams: { values: reasonCodes },
                            editable: params => true
                        },
                    ]
                }, {
                    headerName: TOWER_DEPROP_3,
                    field: 'TOWER_DEPROP_3',
                    headerTooltip: DEPROP3_PI_TAG,
                    children: [
                        {
                            field: TOWER_DEPROP_3_HoursOffline,
                            headerName: 'Hrs Offline',
                            width: 85,
                            filter: 'agNumberColumnFilter',
                            floatingFilter: true,
                            cellStyle: (params) => paintColumnInGrey(params)
                        },
                        {
                            field: TOWER_DEPROP_3_ADJHRSOFFLINE,
                            headerName: 'Adj Hrs Offline',
                            cellEditor: "NumericCellEditor",
                            width: 85,
                            editable: params => true,
                            cellClassRules: gridCellClassRulesEditable
                        },
                        {
                            headerName: 'Reason',
                            field: TOWER_DEPROP_3_Reason,
                            width: 75,
                            filter: 'agTextColumnFilter',
                            floatingFilter: true,
                            cellEditor: "agSelectCellEditor",
                            cellEditorParams: { values: reasonCodes },
                            editable: params => true
                        },
                    ]
                }, {
                    headerName: TOWER_DEPROP_4,
                    field: 'TOWER_DEPROP_4',
                    headerTooltip: DEPROP4_PI_TAG,
                    children: [
                        {
                            field: TOWER_DEPROP_4_HoursOffline,
                            headerName: 'Hrs Offline',
                            width: 85,
                            filter: 'agNumberColumnFilter',
                            floatingFilter: true,
                            cellStyle: (params) => paintColumnInGrey(params)
                        },
                        {
                            field: TOWER_DEPROP_4_ADJHRSOFFLINE,
                            headerName: 'Adj Hrs Offline',
                            cellEditor: "NumericCellEditor",
                            width: 85,
                            editable: params => true,
                            cellClassRules: gridCellClassRulesEditable
                        },
                        {
                            headerName: 'Reason',
                            field: TOWER_DEPROP_4_Reason,
                            width: 75,
                            filter: 'agTextColumnFilter',
                            floatingFilter: true,
                            cellEditor: "agSelectCellEditor",
                            cellEditorParams: { values: reasonCodes },
                            editable: params => true
                        },
                    ]
                },
            ],
        },
        {
            headerName: 'Debutanizers',
            children: [
                {
                    headerName: TOWER_DEBUT_1,
                    field: 'TOWER_DEBUT_1',
                    headerTooltip: DEBUT1_PI_TAG,
                    children: [
                        {
                            field: TOWER_DEBUT_1_HoursOffline,
                            headerName: 'Hrs Offline',
                            width: 85,
                            filter: 'agNumberColumnFilter',
                            floatingFilter: true,
                            cellStyle: (params) => paintColumnInGrey(params)

                        },
                        {
                            field: TOWER_DEBUT_1_ADJHRSOFFLINE,
                            headerName: 'Adj Hrs Offline',
                            cellEditor: "NumericCellEditor",
                            width: 85,
                            editable: params => true,
                            cellClassRules: gridCellClassRulesEditable
                        },
                        {
                            headerName: 'Reason',
                            field: TOWER_DEBUT_1_Reason,
                            width: 75,
                            filter: 'agTextColumnFilter',
                            floatingFilter: true,
                            cellEditor: "agSelectCellEditor",
                            cellEditorParams: { values: reasonCodes },
                            editable: params => true
                        },
                    ]
                },
                {
                    headerName: TOWER_DEBUT_3,
                    field: 'TOWER_DEBUT_3',
                    headerTooltip: DEBUT3_PI_TAG,
                    children: [
                        {
                            field: TOWER_DEBUT_3_HoursOffline,
                            headerName: 'Hrs Offline',
                            width: 85,
                            filter: 'agNumberColumnFilter',
                            floatingFilter: true,
                            cellStyle: (params) => paintColumnInGrey(params)

                        },
                        {
                            field: TOWER_DEBUT_3_ADJHRSOFFLINE,
                            headerName: 'Adj Hrs Offline',
                            cellEditor: "NumericCellEditor",
                            width: 85,
                            editable: params => true,
                            cellClassRules: gridCellClassRulesEditable
                        },
                        {
                            headerName: 'Reason',
                            field: TOWER_DEBUT_3_Reason,
                            width: 75,
                            filter: 'agTextColumnFilter',
                            floatingFilter: true,
                            cellEditor: "agSelectCellEditor",
                            cellEditorParams: { values: reasonCodes },
                            editable: params => true
                        },
                    ]
                }, {
                    headerName: TOWER_DEBUT_4,
                    field: 'TOWER_DEBUT_4',
                    headerTooltip: DEBUT4_PI_TAG,
                    children: [
                        {
                            field: TOWER_DEBUT_4_HoursOffline,
                            headerName: 'Hrs Offline',
                            width: 85,
                            filter: 'agNumberColumnFilter',
                            floatingFilter: true,
                            cellStyle: (params) => paintColumnInGrey(params)

                        },
                        {
                            field: TOWER_DEBUT_4_ADJHRSOFFLINE,
                            headerName: 'Adj Hrs Offline',
                            cellEditor: "NumericCellEditor",
                            width: 85,
                            editable: params => true,
                            cellClassRules: gridCellClassRulesEditable
                        },
                        {
                            headerName: 'Reason',
                            field: TOWER_DEBUT_4_Reason,
                            width: 75,
                            filter: 'agTextColumnFilter',
                            floatingFilter: true,
                            cellEditor: "agSelectCellEditor",
                            cellEditorParams: { values: reasonCodes },
                            editable: params => true
                        },
                    ]
                },
            ],
        },
        {
            headerName: 'Splitters',
            children: [
                {
                    headerName: TOWER_SPLITTER_1,
                    field: 'TOWER_SPLITTER_1',
                    headerTooltip: SPLITTER1_PI_TAG,
                    children: [
                        {
                            field: TOWER_SPLITTER_1_HoursOffline,
                            headerName: 'Hrs Offline',
                            width: 85,
                            filter: 'agNumberColumnFilter',
                            floatingFilter: true,
                            cellStyle: (params) => paintColumnInGrey(params)

                        },
                        {
                            field: TOWER_SPLITTER_1_ADJHRSOFFLINE,
                            headerName: 'Adj Hrs Offline',
                            cellEditor: "NumericCellEditor",
                            width: 85,
                            editable: params => true,
                            cellClassRules: gridCellClassRulesEditable
                        },
                        {
                            headerName: 'Reason',
                            field: TOWER_SPLITTER_1_Reason,
                            width: 75,
                            filter: 'agTextColumnFilter',
                            floatingFilter: true,
                            cellEditor: "agSelectCellEditor",
                            cellEditorParams: { values: reasonCodes },
                            editable: params => true
                        },
                    ]
                },
                {
                    headerName: TOWER_SPLITTER_3,
                    field: 'TOWER_SPLITTER_3',
                    headerTooltip: SPLITTER3_PI_TAG,
                    children: [
                        {
                            field: TOWER_SPLITTER_3_HoursOffline,
                            headerName: 'Hrs Offline',
                            width: 85,
                            filter: 'agNumberColumnFilter',
                            floatingFilter: true,
                            cellStyle: (params) => paintColumnInGrey(params)

                        },
                        {
                            field: TOWER_SPLITTER_3_ADJHRSOFFLINE,
                            headerName: 'Adj Hrs Offline',
                            cellEditor: "NumericCellEditor",
                            width: 85,
                            editable: params => true,
                            cellClassRules: gridCellClassRulesEditable
                        },
                        {
                            headerName: 'Reason',
                            field: TOWER_SPLITTER_3_Reason,
                            width: 75,
                            filter: 'agTextColumnFilter',
                            floatingFilter: true,
                            cellEditor: "agSelectCellEditor",
                            cellEditorParams: { values: reasonCodes },
                            editable: params => true
                        },
                    ]
                }, {
                    headerName: TOWER_SPLITTER_4,
                    field: 'TOWER_SPLITTER_4',
                    headerTooltip: SPLITTER4_PI_TAG,
                    children: [
                        {
                            field: TOWER_SPLITTER_4_HoursOffline,
                            headerName: 'Hrs Offline',
                            width: 85,
                            filter: 'agNumberColumnFilter',
                            floatingFilter: true,
                            cellStyle: (params) => paintColumnInGrey(params)

                        },
                        {
                            field: TOWER_SPLITTER_4_ADJHRSOFFLINE,
                            headerName: 'Adj Hrs Offline',
                            cellEditor: "NumericCellEditor",
                            width: 85,
                            editable: params => true,
                            cellClassRules: gridCellClassRulesEditable
                        },
                        {
                            headerName: 'Reason',
                            field: TOWER_SPLITTER_4_Reason,
                            width: 75,
                            filter: 'agTextColumnFilter',
                            floatingFilter: true,
                            cellEditor: "agSelectCellEditor",
                            cellEditorParams: { values: reasonCodes },
                            editable: params => true
                        },
                    ]
                }, {
                    headerName: TOWER_SPLITTER_6,
                    field: 'TOWER_SPLITTER_6',
                    headerTooltip: SPLITTER6_PI_TAG,
                    children: [
                        {
                            field: TOWER_SPLITTER_6_HoursOffline,
                            headerName: 'Hrs Offline',
                            width: 85,
                            filter: 'agNumberColumnFilter',
                            floatingFilter: true,
                            cellStyle: (params) => paintColumnInGrey(params)

                        },
                        {
                            field: TOWER_SPLITTER_6_ADJHRSOFFLINE,
                            headerName: 'Adj Hrs Offline',
                            cellEditor: "NumericCellEditor",
                            width: 85,
                            editable: params => true,
                            cellClassRules: gridCellClassRulesEditable
                        },
                        {
                            headerName: 'Reason',
                            field: TOWER_SPLITTER_6_Reason,
                            width: 75,
                            filter: 'agTextColumnFilter',
                            floatingFilter: true,
                            cellEditor: "agSelectCellEditor",
                            cellEditorParams: { values: reasonCodes },
                            editable: params => true
                        },
                    ]
                }
            ],
        },
        {
            headerName: 'Upgrader',
            children: [
                {
                    headerName: TOWER_UPGRADER,
                    field: 'TOWER_UPGRADER',
                    headerTooltip: UPGRADER_PI_TAG,
                    children: [
                        {
                            field: TOWER_UPGRADER_HoursOffline,
                            headerName: 'Hrs offline',
                            width: 85,
                            filter: 'agNumberColumnFilter',
                            floatingFilter: true,
                            cellStyle: (params) => paintColumnInGrey(params)

                        },
                        {
                            field: TOWER_UPGRADER_ADJHRSOFFLINE,
                            headerName: 'Adj Hrs Offline',
                            cellEditor: "NumericCellEditor",
                            width: 85,
                            editable: params => true,
                            cellClassRules: gridCellClassRulesEditable
                        },
                        {
                            headerName: 'Reason',
                            field: TOWER_UPGRADER_Reason,
                            width: 75,
                            filter: 'agTextColumnFilter',
                            floatingFilter: true,
                            cellEditor: "agSelectCellEditor",
                            cellEditorParams: { values: reasonCodes },
                            editable: params => true
                        },
                    ]
                }
            ],
        },
        {
            headerName: 'Updated By',
            field: 'UpdatedBy',
            cellStyle: params => paintColumnInGrey(params),
            cellClassRules: gridCellClassRulesNonEditable
        },
        {
            headerName: 'Updated On',
            field: 'UpdatedOn',
            cellRenderer: params => {
                let utcTime = params?.value
                let localTime = null
                if (utcTime) {
                    utcTime = new Date(utcTime)
                    localTime = moment(utcTime).format('D-MMM-YYYY h:mm A')
                }
                return localTime || utcTime
            },
            cellStyle: params => paintColumnInGrey(params)
        }
    ]
}